<!-- 折叠面板 -->
<template>
  <el-collapse-item 
    v-bind="$attrs"
    class="collapse-item"
  >
    <template slot="title">
      <i v-if="hasLinker" class="collapse-item__linker"></i>
      <slot name="title">{{ title }}</slot>
    </template>
    <slot />
  </el-collapse-item>
</template>

<script>
export default {
  props: {
    // 头部是否显示连接符
    hasLinker: {
      type: Boolean,
      default: true
    },
    title: String
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

$height: 36px;
$borderRadius: $--border-radius-base2;
$borderColor: #E6E6E6;
$borderColorHover: #d0d0d0;

.collapse-item {
  margin-bottom: 6px;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    border-color: $borderColorHover;
    // box-shadow: 0px 0px 5px 0px rgba(127, 127, 127, 0.35);
    & ::v-deep {
      .el-collapse-item__header,
      .el-collapse-item__wrap {
        border-color: $borderColorHover;
      }
      .el-collapse-item__header.is-active {
        border-bottom-color: $borderColor;
      }
    }
  }
  & ::v-deep {
    .el-collapse-item__header {
      position: relative;
      padding: 0 5px 0 13px;
      height: $height;
      line-height: $height;
      font-size: 14px;
      font-weight: 700;
      color: $--color-text-important;
      border: 1px solid $borderColor;
      background-color: #FCFCFC;
      border-radius: $borderRadius $borderRadius 0px 0px;
      // &:hover {
      //   background: rgba(255, 77, 79, 0.22);
      // }
      &:not(.is-active) {
        border-radius: $borderRadius;
        &::after { 
          content: '已折叠';
          position: absolute;
          right: 29px;
          font-size: 12px;
          font-weight: 400;
          color: #D0D0D0;
        }
      }
    }
    
    .el-collapse-item__wrap {
      border: 1px solid $borderColor;
      border-top: 0;
      border-radius: 0px 0px $borderRadius $borderRadius;
    }
    .el-collapse-item__content {
      padding: 16px;
      padding-bottom: 2px
    }

    .collapse-item__linker {
      @include moduleLinkerMixin(8px, vertical, #fff);
      position: absolute;
      top: -10px;
      left: 4px;
    }
  }
}
</style>